import { Injectable, inject } from '@angular/core';
import { AppServiceStatusNotification, FeatureFlagService } from '@feature-flag';
import { catchError, of, take } from 'rxjs';

import { ToasterService } from '#shared/components/toaster/toaster.service';

@Injectable({
  providedIn: 'root',
})
export class AppStatusToastService {
  private readonly featureFlagService = inject(FeatureFlagService);
  private readonly toasterService = inject(ToasterService);

  private readonly toastId = 'app-status-toast';
  private readonly defaultFlagValue: AppServiceStatusNotification = { enabled: false };

  constructor() {
    this.checkAndShowNotification();
  }

  private checkAndShowNotification(): void {
    this.featureFlagService
      .getJsonFlagValue<AppServiceStatusNotification>(
        'support-app-status-toast',
        this.defaultFlagValue,
      )
      .pipe(
        take(1),
        catchError(() => of(this.defaultFlagValue)),
      )
      .subscribe((notification) => {
        if (notification.enabled && notification.message) {
          this.toasterService.showWarning(
            notification.message,
            this.toastId,
            null,
            notification.title,
          );
        }
      });
  }
}
